

  <div class="modal-signup modal-content max-width-80pe border-all-10px-modal">
    <div>
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12   document">


        <div class="card-header wh-header padding-bottom-10px border-bottom-1px">

          <div class="row">
            <div class="col-md-1 padding-right-0px padding-left-6px" *ngIf="PatientImage">
              <img class="img-circle-56" [src]="PatientImage" onError="this.src='dummy.jpg';">
            </div>
            <div class="col-md-2 line-height-17px padding-left-0px padding-right-0px">
              <label class="margin-bottom-0px color5 font-weight-bold font-size-16px margin-bottom-0px" *ngIf="PatientName">{{PatientName}}</label>
              <div><label class="margin-bottom-0px font-size-14 font-weight-normal" *ngIf="FormattedCode">{{FormattedCode}}</label></div>
              <div><label class="margin-bottom-0px font-size-14 font-weight-normal" *ngIf="Telephone1">{{Telephone1}}</label></div>
            </div>
            <!--<div class="col-md-3" *ngIf="PatientDetails">

  </div>-->
            <div class="col-md-4 line-height-17px">
            </div>


            
            <div class="col-md-5">

              <!--<button type="button" class="close float-right" data-dismiss="modal"
            (click)="activeModal.dismiss('Cross click')"
            aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>-->
              <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3  font-size-15px float-right margin-left-5px" (click)="Close()">Close</button>

              <button (click)="AddData()" class="btn actions-btn-prime float-right font-size-15px " *ngIf="TotalRefund==LNetPayable">Submit</button>
              <!--<button (click)="AddData()" class="btn actions-btn-prime float-right font-size-15px " *ngIf="Balance!==LNetPayable && LNetPayable>0">Pay Partial Amount</button>-->
            </div>
          </div>
          <!--{{ sectionData.Title }}-->


        </div>
        <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-0px padding-left-0px">
          <div class="row border-top border-bottom bk-color-light margin-left-0px margin-right-0px">
            <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
              <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Bill Date</label></div>
              <div><label class="margin-bottom-0px font-size-16px color-Assign font-weight-bold" *ngIf="BillDate">{{BillDate| date:'MMM-dd-yyyy'}}</label></div>
            </div>
            <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
              <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Branch</label></div>
              <div><label class="margin-bottom-0px font-size-16px color-Assign font-weight-bold" *ngIf="BranchName">{{BranchName}}</label></div>
            </div>
            <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
              <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Total Bill</label></div>
              <div><label class="margin-bottom-0px font-size-16px color-Assign font-weight-bold" *ngIf="TotalBill">{{TotalBill| number:'1.0'|removeComma}}</label></div>
            </div>

            <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
              <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Discount</label></div>
              <div><label class="margin-bottom-0px font-size-16px color-Assign font-weight-bold" *ngIf="Discount">{{Discount| number:'1.0'|removeComma}}</label></div>
            </div>
            
            <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
              <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Total Refundable</label></div>
              <div><label class="margin-bottom-0px font-size-16px color-Assign font-weight-bold" *ngIf="TotalRefund">{{TotalRefund}}</label></div>
            </div>
            <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
              <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Paid</label></div>
              <div><label class="margin-bottom-0px font-size-16px color-checkout font-weight-bold" *ngIf="LNetPayable">{{LNetPayable}}</label></div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <div class="card">


                <div class="card-header wh-header border-bottom padding-bottom-0px">
                  <div class="row border-bottom">
                    <div class="col-md-12">
                      <label class="margin-bottom-0px">Payment</label>
                    </div>

                  </div>
                </div>
                <div class="card-body padding-top-5px padding-bottom-0px padding-left-0px">

                  <!--<div class="row margin-left-0px">
                    <div class="col-md-3">
                      <input type="checkbox" class="width-23px height-16px margin-top-3px"
                             [(ngModel)]="IsSelected2" (change)="checked2($event)">
                      <i class="input-helper"></i>

                     <label class="margin-bottom-0px position-absoulte margin-top-2px font-size-13px">Use Advance Settlement :</label>
                    </div>

                    <div class="col-md-3" *ngIf="IsSelected2">
                      <label class="margin-bottom-0px position-absoulte margin-top-2px font-size-13px">{{AdvanceAmount}}</label>
                    </div>

                  </div>-->
                  <!--<div class="row margin-bottom-20px line-height-5px margin-left-0px" >
                    <div class="col-md-3 text-align-center padding-right-4px">

                      <label class="margin-bottom-0px position-absoulte margin-top-2px font-size-13px">Enter Amount :</label>
                    </div>

                    <div class="col-md-3">
                      <label class="margin-bottom-0px position-absoulte margin-top-2px font-size-13px" *ngIf="NetPayable">{{NetPayable}}</label>
                    </div>

                  </div>-->
                  <div class="row margin-bottom-20px">

                    <div class="col-md-12 padding-right-0px">
                      <div class="table-component margin-left-20p">
                        <div class="table-responsive">


                          <table class="table table-striped margin-left-zero width-100">

                            <thead class="">
                              <tr>

                                <th class="min-width-103px padding-top-4px padding-bottom-4px"></th>
                                <th class="min-width-157px padding-top-4px padding-bottom-4px">Amount</th>

                                <th class="th-width-170px padding-top-4px padding-bottom-4px">Charges</th>
                                <th class="th-width-170px padding-top-4px padding-bottom-4px">Ref.No</th>
                                <th class="padding-top-4px padding-bottom-4px">Details</th>
                              </tr>
                            </thead>
                            <tbody class="table-body">

                              <tr *ngFor="let l of CurrentPaymentDetails;let i = index">
                                <td class="td-padding">

                                  <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                         [(ngModel)]="l.IsSelected" (change)="unchecked($event,l,i)">
                                  <i class="input-helper"></i>

                                  <label class="margin-bottom-0px position-absoulte margin-top-2px">{{l.PaymentMode}}</label>



                                </td>
                                <td>
                                  <input type="text" class="form-control text-align-right"
                                         min="1" max="10" id="l.Amount"
                                         [(ngModel)]="l.Amount" (input)="netpayablesum('add')"
                                         name="l.Amount" pattern="^[\0-9,._\-?]*$"
                                         maxlength="10" *ngIf="l.IsSelected" #AmountCash="ngModel">

                                </td>
                                <td class="text-align-right">
                                  <input type="text" class="form-control text-align-right"
                                         min="1" max="10" id="l.Charges"
                                         [(ngModel)]="l.Charges"
                                         name="l.Charges" pattern="^[\0-9,._\-?]*$" #ChargesCash="ngModel"
                                         maxlength="10" *ngIf="l.IsSelected">

                                </td>

                                <td class="td-padding ">

                                  <input type="text" class="form-control"
                                         min="1" max="10" id="l.Refno"
                                         [(ngModel)]="l.Refno"
                                         name="l.Refno" pattern="^[\0-9,._\-?]*$" #RefnoCash="ngModel"
                                         maxlength="10" *ngIf="l.IsSelected">


                                </td>

                                <td>
                                  <input type="text" class="form-control"
                                         min="1" max="10" id="l.Details"
                                         [(ngModel)]="l.Details"
                                         name="l.Details" pattern="^[\0-9,._\-?]*$" #DetailsCash="ngModel"
                                         maxlength="10" *ngIf="l.IsSelected">

                                </td>



                              </tr>

                            </tbody>

                          </table>

                        </div>
                      </div>
                    </div>

                  </div>
                </div>






              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

 
